import React, { useContext, useEffect, useState, useRef } from 'react';

import { applyFilter } from './DealFilterHelpers';
import { DataContext as DealDataContext } from '../../../stores/crm-deal-store';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import { DataContext as MainDataContext } from '../../../store';
import { createGetSuggestionsFromApiUrl } from '../shared/field_inputs/HelpMethods';
import EditType from '../shared/field_inputs/type/EditType';
import EditSelect from '../shared/field_inputs/select/EditSelect';
import EditItemList from '../shared/field_inputs/item_list/EditItemList';
import Overlay from 'react-bootstrap/Overlay';
import Popover from 'react-bootstrap/Popover';
import { getIcon } from '../shared/field_inputs/shared/FormatHelpers';

export const DealSelectUsers = () => {
    // Data context variables
    const {
        store: {userFilterType, selectedUsersOptions, selectedUserGroupOption, selectedBossGroupOption, selectedTeamGroupOption,
            /*pipelines,
            currentPipelineId,
            apiUrl,*/
        },
        dispatch: dealDispatch,
    } = useContext(DealDataContext);

    const {
        store: { bossGroups, officeOptions, userFilterTypes, teamsOptions},
    } = useContext(SharedDataContext);
    const {
        store: { user: signedInUser },
    } = useContext(MainDataContext);

    // Selection states
    const setUserFilterType = (type) => dealDispatch({ type: 'SET_USER_FILTER_TYPE', payload: type });
    const setSelectedUsersOptions = (options) => dealDispatch({ type: 'SET_SELECTED_USERS_OPTIONS', payload: options });
    const setSelectedUserGroupOption = (option) => dealDispatch({ type: 'SET_SELECTED_USER_GROUP_OPTION', payload: option });
    const setSelectedBossGroupOption = (option) => dealDispatch({ type: 'SET_SELECTED_BOSS_GROUP_OPTION', payload: option });
    const setSelectedTeamGroupOption = (option) => dealDispatch({ type: 'SET_SELECTED_TEAM_GROUP_OPTION', payload: option });

    // Update fetch settings
    /*const handleUpdateUsers = (filterKey, users) => {
        let newFilterUsers = [];
        switch (filterKey) {
            case 'Users':
                newFilterUsers = users.map((item) => {
                    return {
                        id: item.id,
                        name: item.name,
                    };
                });
                break;
            case 'Boss':
                if (users.length !== 0) {
                    newFilterUsers = {
                        id: users.id,
                        name: users.name,
                        coaEmpId: users.coaEmpId
                    }
                }
                break;
            case 'Group':

                if (users.length !== 0) {
                    newFilterUsers = {
                        id: users.id,
                        name: users.name
                    }
                }
                break;
            case 'Team':
                newFilterUsers = users.map((item) => {
                    return {
                        id: item.id,
                        name: item.name,
                    };
                });
                break;
        }

        const newSerializedFilterUsers = JSON.stringify(newFilterUsers);
        pipelines[currentPipelineId].filterOptions['Users'] = newSerializedFilterUsers;
        //pipelines[currentPipelineId].filterOptions['Type'] = localStorage.getItem('deal-user-filter-type');
        applyFilter(filterKey, newSerializedFilterUsers, apiUrl, dealDispatch, pipelines, currentPipelineId);
    };
    useEffect(
        () => {
            localStorage.setItem(`deal-user-filter-type`, JSON.stringify(userFilterType));
            switch (userFilterType.id) {
                case 'user':
                    localStorage.setItem(`deal-selected-users-options`, JSON.stringify(selectedUsersOptions ?? []));
                    handleUpdateUsers('Users', selectedUsersOptions ?? []);
                    break;
                case 'boss':
                    localStorage.setItem(`deal-selected-boss-group-option`, JSON.stringify(selectedBossGroupOption ?? []));
                    handleUpdateUsers('Boss', selectedBossGroupOption ?? []);
                    break;
                case 'group':
                    localStorage.setItem(`deal-selected-user-group-option`, JSON.stringify(selectedUserGroupOption ?? []));
                    handleUpdateUsers('Group', selectedUserGroupOption ?? []);
                    break;
                case 'team':
                    localStorage.setItem(`deal-selected-team-group-option`, JSON.stringify(selectedTeamGroupOption ?? []));
                    handleUpdateUsers('Team', selectedTeamGroupOption?.users ?? []);
                    break;
                default:
                    break;
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [userFilterType, selectedUsersOptions, selectedBossGroupOption, selectedUserGroupOption, selectedTeamGroupOption]
    );*/

    // Set select component
    let selectComponent;
    switch (userFilterType.id) {
        case 'user':
            selectComponent = (
                <EditItemList
                    value={selectedUsersOptions}
                    setValue={setSelectedUsersOptions}
                    getSuggestions={createGetSuggestionsFromApiUrl('api/crmUserFront/getUserSuggestions')}
                    iconName={'user'}
                />
            );
            break;
        case 'boss':
            selectComponent = (
                <EditSelect
                    value={selectedBossGroupOption}
                    setValue={setSelectedBossGroupOption}
                    options={bossGroups}
                    iconName={userFilterType.icon}
                />
            );
            break;
        case 'group':
            selectComponent = (
                <EditSelect
                    value={selectedUserGroupOption}
                    setValue={setSelectedUserGroupOption}
                    options={officeOptions}
                    iconName={userFilterType.icon}
                />
            );
            break;
        case 'team':
            selectComponent = (
                <EditSelect
                    value={selectedTeamGroupOption}
                    setValue={setSelectedTeamGroupOption}
                    options={teamsOptions}
                    iconName={userFilterType.icon}
                />
            );
            break;
        default:
            selectComponent = null;
            break;
    }

    // Group popover user list
    let showUsersComponent = null;
    if (userFilterType.id === 'boss' && selectedBossGroupOption?.users?.length) {
        showUsersComponent = <ShowUsersComponent group={selectedBossGroupOption} icon={userFilterType.icon} />;
    } else if (userFilterType.id === 'group' && selectedUserGroupOption?.users?.length) {
        showUsersComponent = <ShowUsersComponent group={selectedUserGroupOption} icon={userFilterType.icon} />;
    }else if (userFilterType.id === 'team' && selectedTeamGroupOption?.users?.length) {
        showUsersComponent = <ShowUsersComponent group={selectedTeamGroupOption} icon={userFilterType.icon} />;
    }

    // Show my deals option
    const showMyDeals = () => {
        setSelectedUsersOptions([{ id: signedInUser.crmUserId, name: signedInUser.name }]);
    };

    const showMyDealsComponent = (
        <div className='cursor-pointer user-select-none discrete-filter-dropdown-gray-small-text' onClick={showMyDeals}>
            Mina deals
        </div>
    );

    return (
        <div className='select-filter-container'>
            <div className='d-flex align-items-center'>
                <EditType value={userFilterType} setValue={setUserFilterType} options={userFilterTypes} size={'sm'} />
                {userFilterType.id === 'user' ? showMyDealsComponent : showUsersComponent}
            </div>
            <div className='mt-1' />
            {selectComponent}
        </div>
    );
};

const ShowUsersComponent = ({ group, icon }) => {
    const users = group.users;
    var userHtmlList;
    if(users[0].id != null){
        userHtmlList = users.map((object) => '• ' + object.name).reduce((prev, next) => '' + prev + '\n' + next);
    }else{
        userHtmlList = users.map((object) => '• ' + object).reduce((prev, next) => '' + prev + '\n' + next);
    }
    const numberOfMembers = users.length;

    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const ref = useRef(null);

    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };


    return (
        <div ref={ref}>
            <div
                onClick={handleClick}
                className='d-flex user-select-none cursor-pointer align-items-center discrete-filter-dropdown-gray-small-text'>
                {'Visa ' + numberOfMembers + ' medlemmar'}
            </div>
            <Overlay
                show={show}
                target={target}
                rootClose={true}
                placement='right-start'
                container={ref.current}
                containerPadding={20}
                onHide={() => { }}>
                <Popover id='show-users-popover'>
                    <Popover.Title>
                        <div className='crm-editable-field-wrapper my-1'>
                            <div className='select-wrapper'>
                                <div className='select '>
                                    {getIcon(icon)}
                                    <div className='select-text'>{group.name}</div>
                                </div>
                            </div>
                        </div>
                    </Popover.Title>
                    <Popover.Content className='show-users-popover-content'>{userHtmlList}</Popover.Content>
                </Popover>
            </Overlay>
        </div>
    );
};
